import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import GeneralSelect from '../select/select.component';
import MultiValue from './value.component';

import AppkitIcon from '../appkitIcon/appkitIcon.component';

const selectOptionValuePropType = PropTypes.shape({
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string,
});

const Select = ({
  className,
  multi = false,
  clearable = false,
  onChange,
  value,
  ...rest
}) => {
  const classNames = classnames(className, 'sdk-custom-select');

  const showClearIcon = clearable && Boolean(value);

  const clearSelection = useCallback(() => {
    onChange(null);
  }, [onChange]);

  return (
    <div className="sdk-custom-select-wrapper">
      <GeneralSelect
        className={classNames}
        multi={multi}
        components={multi ? { MultiValue } : {}}
        onChange={onChange}
        value={value}
        clearable={clearable}
        {...rest}
      />
      <AppkitIcon
        className="sdk-custom-select-appkit-icon"
        icon="down-chevron"
        type="fill"
        size={12}
      />
      {
        showClearIcon && (
          <AppkitIcon
            className="clear-icon"
            icon="close"
            type="fill"
            size={8}
            onClick={clearSelection}
          />
        )
      }
    </div>
  );
};

Select.propTypes = {
  className: PropTypes.string,
  multi: PropTypes.bool,
  clearable: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    selectOptionValuePropType,
    PropTypes.arrayOf(selectOptionValuePropType),
  ]),
};

export default Select;
